import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    AppBar,
    Toolbar,
    colors,
    Tabs,
    Tab,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Grow,
    Button,
    ClickAwayListener
} from '@mui/material';
import Logo from '../../src/components/Logo';
import { useSelector } from 'react-redux';
import { useLogout } from '../hooks/useAuth';
import "./Layout.css";

const TopBar = ({ onMobileNavOpen, value, handleTabChange, handleMobleTabChange, setMobileNavOpen, isMobileNavOpen }) => {
    const [notifications] = useState([{}, {}]);
    const auth = useSelector((state) => state.UserReducer.isAuthenticated);
    const logout = useLogout();

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
  
    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };
  
    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
  
      setOpen(false);
    };
  
    function handleListKeyDown(event) {
      if (event.key === 'Tab') {
        event.preventDefault();
        setOpen(false);
      } else if (event.key === 'Escape') {
        setOpen(false);
      }
    }

    return (
        <AppBar
            elevation={0}
            sx={{ backgroundColor: colors.grey[900] }}
        >
            <Toolbar style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <RouterLink to="/" className="logo" onClick={() => handleMobleTabChange(0)}>
                    <Logo className="logoImage"/>
                </RouterLink>
                    <div className='mobileTabs'>
                        <Button className="mobileTabButton" value={0} onClick={()=>{ handleMobleTabChange(0)}}>Home</Button>
                        { auth &&
                            <Button className="mobileTabButton" value={4} onClick={()=>{ handleMobleTabChange(4)}}>Portal</Button>
                        }
                        <Button
                            ref={anchorRef}
                            id="composition-button"
                            aria-controls={open ? 'composition-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={handleToggle}
                            className="mobileTabs mobileTabButton"
                            sx={{border:"solid white 1px !important", borderRadius:"5px"}}
                        >
                            Menu
                        </Button>
                        <Popper
                            open={open}
                            anchorEl={anchorRef.current}
                            role={undefined}
                            placement="bottom-start"
                            transition
                            disablePortal
                            >
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin:
                                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                                    }}
                                >
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList
                                            autoFocusItem={open}
                                            id="composition-menu"
                                            aria-labelledby="composition-button"
                                            onKeyDown={handleListKeyDown}
                                        >
                                            <MenuItem value={1} onClick={(event)=>{handleClose, handleMobleTabChange(event.target.value)}}>Tutorials</MenuItem>
                                            <MenuItem value={2} onClick={(event)=>{handleClose, handleMobleTabChange(event.target.value)}}>About</MenuItem>
                                            <MenuItem value={3} onClick={(event)=>{handleClose, handleMobleTabChange(event.target.value)}}>Contact</MenuItem>
                                        </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                        { !auth ?
                            <Button className="mobileTabButton" value={4} onClick={()=>{ handleMobleTabChange(4)}}>Login</Button>
                            :
                            <Button href="/" className="mobileTabButton" value={4} onClick={() => logout()}>Logout</Button>
                        }
                    </div>
                    <div className='tabParent'>
                        <Tabs value={value} onChange={handleTabChange}>
                            <Tab label="Home" className="tabChild" />
                            <Tab label="Tutorials" className="tabChild" />
                            <Tab label="About" className="tabChild" />
                            <Tab label="Contact" className="tabChild" />
                            { auth &&
                                <Tab label="Portal" className="tabChild" />
                            }
                            { !auth ?
                                <Tab value={4} label="Login" className="tabChild" />
                                :
                                <Tab href="/" value={4} onClick={() => logout()} label="Logout" className="tabChild" />
                            }
                        </Tabs>
                    </div>
            </Toolbar>
        </AppBar>
    );
};

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func
};

export default TopBar;